import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import TimesheetDocument from '../components/timesheet/TimesheetDocument';
import TimesheetToolbar from '../components/timesheet/TimesheetToolbar';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TimesheetPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [timesheet, setTimesheet] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(() => {
    const fetchTimesheet = async () => {
      try {
        // Fetch the weekly timesheet
        const response = await axios.get(`${API}/timesheets/weekly/${id}`);
        const data = response.data;
        
        setTimesheet(data);
        setEntries(data.entries || []);
      } catch (error) {
        console.error('Failed to fetch timesheet:', error);
        toast.error('Failed to load timesheet');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTimesheet();
    }
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate('/timesheet');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="w-6 h-6 animate-spin" />
          <span>Loading timesheet...</span>
        </div>
      </div>
    );
  }

  if (!timesheet) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <p className="text-slate-600 mb-4">Timesheet not found</p>
          <button 
            onClick={handleBack}
            className="text-amber-600 hover:text-amber-700 font-medium"
          >
            Back to Timesheets
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 print:bg-white">
      <TimesheetToolbar 
        onPrint={handlePrint}
        onBack={handleBack}
      />
      <div className="py-10 px-4 flex justify-center print:p-0 print:block" id="print-wrapper">
        <TimesheetDocument 
          timesheet={timesheet}
          entries={entries}
          printRef={printRef} 
        />
      </div>
    </div>
  );
}
